<template>
    <section class="app-main">
        
        <el-card class="m-bottom-4">
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">优惠券类型：</el-col>
               <el-col :span="22">
                  <el-radio v-model="discount" :label="1" border>商品代金券</el-radio>
                  <el-radio v-model="discount" :label="2" border>商品满减券</el-radio>
                  <el-radio v-model="discount" :label="3" border>商品折扣券</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">优惠券金额：</el-col>
               <el-col :span="22" v-if="discount == '1'">
                  <el-input placeholder="请输入代金券金额(C$)" v-model="coupon_money"  style="width:532px;"></el-input>
               </el-col>
               <el-col :span="22" v-if="discount == '2'">
                   <span style="color:#666">满(C$)<el-input placeholder="请输入金额" v-model="full_money" style="width:190px;margin-left:10px"></el-input></span>
                   <span style="margin-left:35px">减(C$)<el-input placeholder="请输入金额" v-model="reduce" style="width:190px;margin-left:10px"></el-input></span>
               </el-col>
               <el-col :span="22" v-if="discount == '3'">
                  <el-input placeholder="请输入商品折扣率(%)，例：打八折，输入20" v-model="coupon_money"  style="width:532px;"></el-input>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">发放数量：</el-col>
               <el-col :span="22">
                   <el-input placeholder="优惠券发放数量" v-model="stock"  style="width:532px;"></el-input>
               </el-col>
           </el-row>
        </el-card>

        <el-card class="m-bottom-4">
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">使用范围：</el-col>
               <el-col :span="22">
                  <el-radio v-model="range" :label="1" border>全平台可用</el-radio>
                  <el-radio v-model="range" :label="2" border>自营商品可用</el-radio>
                  <el-radio v-model="range" :label="3" border>预售商品可用</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">领取规则：</el-col>
               <el-col :span="22">
                  <el-radio v-model="access" :label="1" border>购物后可领</el-radio>
                  <el-radio v-model="access" :label="2" border>登录领取</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">领取方式：</el-col>
               <el-col :span="22">
                  <el-radio v-model="get_coupon" :label="1" border>自动发放</el-radio>
                  <el-radio v-model="get_coupon" :label="2" border>商品详情页显示</el-radio>
                  <el-radio v-model="get_coupon" :label="3" border>兑换码兑换</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">领取限制：</el-col>
               <el-col :span="22">
                  <el-input placeholder="请输入领取数量（默认为0不限制领取数量）" v-model="user_get_num"  style="width:532px;"></el-input>
               </el-col>
           </el-row>
        </el-card>

        <el-card class="m-bottom-4">
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">有效日期：</el-col>
               <el-col :span="22">
                  <el-radio v-model="fixed" :label="1" border>固定日期</el-radio>
                  <el-radio v-model="fixed" :label="2" border>非固定日期</el-radio>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4" v-if="fixed == 1">
               <el-col :span="2" class="input-label">选择日期：</el-col>
               <el-col :span="22">
                   <el-date-picker v-model="fixDate" type="daterange" value-format="timestamp" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-col>
           </el-row>
           <el-row class="m-bottom-4" v-else>
               <el-col :span="2" class="input-label">有效天数：</el-col>
               <el-col :span="22">
                   <el-radio v-model="day_type" :label="0" border>领券后当日开始</el-radio>
                   <el-radio v-model="day_type" :label="1" border>领券后次日开始</el-radio>
                   <el-input placeholder=有效期 v-model="fixed_time"  style="width:183px;"></el-input>
              </el-col>
           </el-row>
        </el-card>

        <el-card class="m-bottom-4">
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">中文图片：</el-col>
               <el-col :span="22">
                   <m-upload :img.sync="pic_zh"  :width="351" :height="114" file-name="Coupon"  placement="right" />
                </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">英文图片：</el-col>
               <el-col :span="22">
                   <m-upload :img.sync="pic_en"  :width="351" :height="114" file-name="Coupon"  placement="right" />
                </el-col>
           </el-row>
        </el-card>

        <el-card class="m-bottom-4">
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">中文说明：</el-col>
               <el-col :span="22">
                   <el-input placeholder="中文说明" v-model="rule" type="textarea" autosize style="width:532px;"></el-input>
               </el-col>
           </el-row>
           <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">英文说明：</el-col>
               <el-col :span="22">
                   <el-input placeholder="英文说明" v-model="rule_en" type="textarea" autosize style="width:532px;"></el-input>
               </el-col>
           </el-row>
        </el-card>

        <el-card>
            <el-row class="m-bottom-4">
               <el-col :span="2" class="input-label">确认提交：</el-col>
               <el-col :span="22">
                   <el-button type="primary" :disabled="disabled"  @click="handleBtn()" style="width:160px;letter-spacing:1.5px;">Done</el-button>
               </el-col>
           </el-row>
        </el-card>

    </section>
</template>



<script>
import { coupon_add } from '@/api/market.js'
import MUpload from '@/components/m-upload.vue'
export default {
    components: { MUpload },
    data() {
        return {
            id: '',
            coupon_money: "",
            rule: "",
            rule_en: "",
            access: 1,
            range: 1,
            stock: '',
            discount: 1,
            get_number: 2,
            full_money: '',
            reduce: '',
            flag: 1,
            fixed: 1,
            fixed_time: '',
            user_get_num: '',
            get_coupon: 1,

            fixDate: [],   //固定日期
            day_type: 1,
            pic_zh: { url: '', pic_id: '' },
            pic_en: { url: '', pic_id: '' },

            disabled: false,
            
        }
    },
    methods: {




        // 显示 添加 || 修改 弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.id        = row.id
                this.name      = row.title
                this.path      = row.path
                this.identify  = row.identify
                this.sort      = row.sort_id
                this.status    = row.status
                this.is_module = row.is_module
                this.pid       = row.pid
            }else{
                this.dialog      = true
                this.id        = ''
                this.name      = ''
                this.path      = ''
                this.identify  = ''
                this.sort      = 0
                this.status    = 0
                this.is_module = 0
                this.pid       = ''
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        handleAdd(){
            let params = {
                discount    : this.discount,
                stock       : this.stock,
                range       : this.range,
                access      : this.access,
                get_coupon  : this.get_coupon,
                user_get_num: this.user_get_num,
                fixed       : this.fixed,
            }

            if( [1,3].includes(this.discount)  ) {
                if(this.coupon_money == '') {
                    this.$message.error('请先完善优惠券金额')
                    return false
                }else {
                     params.coupon_money = this.coupon_money
                }
                
            }else {
                if(this.full_money == '' || this.reduce == '') {
                    this.$message.error('请先完善优惠券满减金额')
                }else {
                    params.full_money =  this.full_money
                    params.reduce       = this.reduce
                }
            }

            if( this.stock == '') {
                this.$message.error('请完善 发放数量')
                return false
            }
            if(this.user_get_num == ''){
                params.user_get_num = 0
            }
            if(this.fixed == 1  ) {
                if(this.fixDate.length != 2) {
                    this.$message.error('请先完善开始日期、结束日期')
                    return false
                }else {
                    params.st_time  = this.fixDate[0]/1000
                    params.end_time = this.fixDate[1]/1000
                }
            }else{
                if(this.fixed_time == '') {
                    this.$message.error('请先完善有效天数')
                    return false
                }else {
                    params.fixed_time = this.fixed_time
                }
            }


            if(this.pic_zh.pic_id == '' || this.pic_zh.pic_id ==  undefined) {
                this.$message.error('请先完善优惠券中文图')
                return false
            }else{
                params.coupon_logo = this.pic_zh.pic_id
            }
            
            if(this.pic_en.pic_id == '' || this.pic_en.pic_id ==  undefined) {
                this.$message.error('请先完善优惠券英文图')
                return false
            }else{
                params.coupon_logo_en = this.pic_en.pic_id
            }

            if(this.rule == '' ) {
                this.$message.error('请先完善优惠券中文说明')
                return false
            }else{
                params.rule = this.rule
            }

            if(this.rule_en == '' ) {
                this.$message.error('请先完善优惠券英文说明')
                return false
            }else{
                params.rule_en = this.rule_en
            }

            

            this.disabled = true
            coupon_add(params).then(res => {
                if(res){
                    this.id=  '';
                    this.coupon_money=  "";
                    this.rule=  "";
                    this.rule_en=  "";
                    this.access=  1;
                    this.range=  1;
                    this.stock=  '';
                    this.discount=  1;
                    this.get_number=  2;
                    this.full_money=  '';
                    this.reduce=  '';
                    this.flag=  1;
                    this.fixed=  1;
                    this.fixed_time=  '';
                    this.user_get_num =  '';
                    this.get_coupon  = 1;
                    this.fixDate =  [];   //固定日期
                    this.day_type =  1;
                    this.pic_zh = { url: '', pic_id: '' };
                    this.pic_en =  { url: '', pic_id: '' };
                    this.disabled  = false;
                    this.$message({message:res.msg,type:'success'});
                }
            }).finally( ()=> {
                this.disabled = false
            })
        }
    },
    created(){
        
    }
}
</script>

<style lang="less" scoped>
    section {
        width: 100%;
        /deep/ .el-radio.is-bordered {
            width: 150px;
        }
        .input-label {
            height: 40px;
            line-height: 40px;
            min-width: 98px;
        }
    }
</style>
